"use client";
import { makeGenericStorageContext } from "../context";
import { makeGenericStorage } from "./genericstorage";
/**
 * sessionStorage operations, define setter, getter and remover for this
 * storage implementation.
 */
const sessionStorageOperations = {
    getItem: (key) => {
        if (typeof window !== "undefined") {
            return window.sessionStorage?.getItem(key);
        }
        return null;
    },
    setItem: (key, value) => {
        if (typeof window !== "undefined") {
            window.sessionStorage?.setItem(key, value || "");
        }
    },
    removeItem: (key) => {
        if (typeof window !== "undefined") {
            window.sessionStorage?.removeItem(key);
        }
    },
};
const { useStorage, Provider } = makeGenericStorage("SessionStorage", sessionStorageOperations, makeGenericStorageContext);
/**
 * Return a sessionStorage store, to be used for interacting with sessionStorage.
 *
 * Usage:
 * ```
 * const sessionStorage = useSessionStorage();
 *
 * const myValue = sessionStorage.getItem("my-key");
 * ```
 *
 * @returns a sessionStorage store.
 * @public
 */
export const useSessionStorage = useStorage;
/**
 * SessionStorageProvider component.
 * This provides a SessionStorage context for your app. Note that directly using
 * this component is only needed if you are not using this via the gatsby plugin.
 *
 * Usage:
 * ```
 * function App = () => {
 *   // Use this provider to pass the
 *   // sessionStorage context to the tree below.
 *   // You can invoke `useSessionStorage` in any
 *   // of the components within.
 *   return (
 *     <SessionStorageProvider>
 *       <MyApp />
 *     </SessionStorageProvider>
 *   );
 * }
 * ```
 */
export const SessionStorageProvider = Provider;
//# sourceMappingURL=sessionstorage.js.map